<template>
	<v-dialog :model-value="dialog" width="1000" persistent scrollable>
		<v-card>
			<v-card-title class="text-h1 font-weight-bold pt-4 px-6">
				Organizations
				<v-spacer></v-spacer>
				<v-btn icon="mdi-close" variant="flat" density="compact" @click="$emit('close')">
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-0">
				<v-list density="compact">
					<v-list-item v-for="org in orgs" :key="org.id"
						:color="org.id === currentOrgId ? 'primary' : ''"
						:active="org.id === currentOrgId"
						:disabled="org.id === currentOrgId"
						@click="changeAccount(org.id)"
					>
						<template v-slot:title> {{ org.company }}</template>
					</v-list-item>
				</v-list>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" variant="outlined" @click="$emit('close')">
					Close
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
/* Libraries */
import {getAccessToken} from "@/services/zettacloud/SessionManager";
import emitter from "@/emitter";

export default {
	name: "OrganizationsManager",

	props: {
		dialog: {
			type: Boolean,
			required: true
		}
	},

	emits: ["close"],

	data() {
		return {
			orgs: []
		}
	},

	computed: {
		currentOrgId() {
			return this.$store.getters.getOrgID();
		},

		availableOrgs() {
			return JSON.parse(localStorage.getItem("user.session"))?.profile?.organizationIds ??
				   this.$store.getters.getAvailableOrganizations();
		}
	},

	methods: {
		changeAccount(orgID) {
			if (orgID !== this.currentOrgId) {
				this.$store.dispatch("resetState", true);
				emitter.emit("set-selected-station", null);
				const user = JSON.parse(localStorage.getItem("user.session"));
				localStorage.removeItem("user.session");
				getAccessToken(user, orgID).then(() => {
					this.$store.dispatch("getFavoriteStations");
				});
				this.$store.commit("setAccount", this.orgs.find(org => org.id === orgID));
				this.$emit("close");
			}
		}
	},

	async mounted() {
		this.orgs = await this.$store.dispatch("getOrganizationsByID", this.availableOrgs);
	}
}
</script>

<style scoped lang="scss">

</style>